import { render, staticRenderFns } from "./UndockIcon.vue?vue&type=template&id=2f3e03f7&"
import script from "./UndockIcon.vue?vue&type=script&lang=ts&"
export * from "./UndockIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports